import React from 'react';
import CustomerInfo from './DriverInfo';
import Orders from './Orders';
import Comments from './Comments/Comments';
import Notes from './Notes';
import Divider from '@material-ui/core/Divider';
import Transactions from './Transactions';
import { makeStyles } from '@material-ui/core/styles';
import Alerts from "./Alerts"

const useStyles = makeStyles((theme) => ({
  divider: {
    margin: theme.spacing(1, 0),
  },
}));

function DriverMainCard() {
  const classes = useStyles();
  return (
    <>
      <Alerts />
      <CustomerInfo />
      <Divider className={classes.divider} />
      <Notes />
      <Divider className={classes.divider} />
      <Orders />
      <Divider className={classes.divider} />
      <Transactions />
      {/* <Divider className={classes.divider} /> */}
      {/* <Comments />
      <Divider className={classes.divider} /> */}
    </>
  );
}

export default React.memo(DriverMainCard);
